import { useState, useEffect } from 'react';
import styles from './ShowJobLists.module.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';



const JobLists = (
    { jobId, listsAll, applications, listName, setListName, selectedList, setSelectedList,selectedApplicants, setSelectedApplicants,}// Default values for props
) => {

    const [lists, setLists] = useState([]);
    const [showJobLists, setShowJobLists] = useState(false);
    const [loading, setLoading] = useState(true);
    const [notification, setNotification] = useState('');
    const [showMakeLists, setShowMakeLists] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        listsAll && setLists(listsAll);
        setLoading(false);
    }, [listsAll]);

    const handleViewList = (list) => {
        setSelectedList(list);
        setSelectedApplicants(list.applicants.map(applicant => applicant._id));
        setShowMakeLists(true);
        handleListSelect(list);
    };
    const handleListSelect = (list) => {
        setSelectedList(list);
        setListName(list.name);
        setSelectedApplicants(list.applicants.map(applicant => applicant._id));
    };

    // Edit list
    const handleEditList = async (list) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/api/recruiter/lists/${jobId}/${list._id}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setListName(listName)
            handleListSelect(list);
            setSelectedList(response.data.list);
            setListName(response.data.list.name);
            setSelectedApplicants(response.data.list.applicants.map(a => a._id));
            setShowMakeLists(true);
        } catch (error) {
            console.error('Error fetching list:', error);
            setNotification('Error loading list details');
        }
    };

    // Delete list
    const handleDeleteList = async (listId) => {
        if (!window.confirm('Are you sure you want to delete this list?')) return;

        try {
            const token = localStorage.getItem('token');
            await axios.delete('/api/recruiter/lists/delete', {
                data: { jobId, listId },
                headers: { 'Authorization': `Bearer ${token}` }
            });
            handleListSelect(listId);
            setLists(lists.filter(list => list._id !== listId));
            setNotification('List deleted successfully');
        } catch (error) {
            console.error('Error deleting list:', error);
            setNotification('Error deleting list');
        }
    };

        // View applicant profile
    const handleViewProfile = (applicantId) => {
        const application = applications.find(app => app.applicantId?._id === applicantId);
        if (application) {
            navigate(`/recruiter/applications/${application._id}`);
        }
    };
    // console.log("listsAll:", listsAll);


    return (

        <div>
 
        {/* {showJobLists && ( */}
            <div className={styles.existingListsContainer}>
                <h3 className={styles.listsHeader}>Existing Lists</h3>
                <div className={styles.listsGrid}>
                    {lists.map(list => (
                        <div key={list._id} className={styles.listCard}>
                            <div className={styles.listHeader}>
                                <h4 className={styles.listName}>{list.name}</h4>
                                <h6 className={styles.listUpdatedAt}>🕒{new Date(list.updated).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                })}
                                </h6>
                                {/* 🗓️📆📅📅🗓️📆🕙🕓🕑🕐  🧗‍♂️🤸‍♂️🚴‍♂️🕺🕵️‍♂️🕴️👷‍♂️👮‍♂️👨‍🔬👨‍🚀👨‍🚒👨🏻‍💼👨‍🎓👨🏻‍🎤👨‍🚒👨‍🎨🏋🏻 */}
                                <span className={styles.applicantCount}>{list.applicants.length}applicants</span>
                            </div>
                            
                            <div className={styles.listActions}>
                                <button 
                                    className={styles.viewButton}
                                    onClick={() => handleViewList(list)}
                                >
                                    View
                                </button>
                                <button 
                                    className={styles.editButton}
                                    onClick={() => handleEditList(list)}
                                >
                                    Edit
                                </button>
                                <button 
                                    className={styles.deleteButton}
                                    onClick={() => handleDeleteList(list._id)}
                                >
                                    Delete
                                </button>
                            </div>
                            
                            <div className={styles.applicantsPreview}>
                                {list.applicants.slice(0, 3).map(applicant => (
                                    <div key={applicant._id} className={styles.applicantItem}>
                                        <span>{applicant.name}</span>
                                        <button 
                                            className={styles.profileButton}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleViewProfile(applicant._id);
                                            }}
                                        >
                                            Profile
                                        </button>
                                    </div>
                                ))}
                                {list.applicants.length > 3 && (
                                    <div className={styles.moreApplicants}>
                                        +{list.applicants.length - 3} more...
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}</div>
            </div>
        {/* )} */}
        </div>
        )}

export default JobLists;